import { render, staticRenderFns } from "./PublicProfileContact.vue?vue&type=template&id=56de7e48&scoped=true&"
import script from "./PublicProfileContact.vue?vue&type=script&lang=js&"
export * from "./PublicProfileContact.vue?vue&type=script&lang=js&"
import style0 from "./PublicProfileContact.vue?vue&type=style&index=0&id=56de7e48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56de7e48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
